import React from "react";
import AppModal from "../common/AppModal";
import CreateNotificationForm from "../../forms/CreateNotificationForm";

interface CreateNotificationModalProps {
  open: boolean;
  onClose: () => void;
  loading: boolean;
  error: string | null;
}

const CreateNotificationModal: React.FC<CreateNotificationModalProps> = ({
  open,
  onClose,
  loading,
  error,
}) => {
  return (
    <AppModal
      open={open}
      onClose={onClose}
      title="New System Notification"
      width="md"
      loading={loading}
    >
      <CreateNotificationForm loading={loading} error={error} />
    </AppModal>
  );
};

export default CreateNotificationModal;
